import type { PtyEndpoints } from '../terminal/use-pty-terminal';

/**
 * Pro Builder's terminal URLs (FRONT-3003): the same request/response/SSE
 * shapes as the app sandbox terminal, under their own base. Prewarm is
 * present because the person's sandbox may still be provisioning when the
 * window opens.
 */
export function proBuilderTerminalEndpoints(): PtyEndpoints {
  const base = '/api/pro-builder/terminal';
  return {
    open: base,
    prewarm: `${base}/prewarm`,
    stream: (id) => `${base}/${id}/stream`,
    input: (id) => `${base}/${id}/input`,
    resize: (id) => `${base}/${id}/resize`,
    kill: (id) => `${base}/${id}`,
  };
}
